import type { QuanLyLop } from '@/services/QuanLyLop';
import { useState } from 'react';
import { useModel } from 'umi';
import {
  createQuyDoi,
  deleteQuyDoi,
  getDanhMucThucPhamQuyDoi, getListThucPham,
  getQuyDoi,
  updateQuyDoi,
} from '@/services/QuyDoi/quydoi';
import { IQuiDoi } from '@/services/QuyDoi';
import { DanhMucThucPham as IDanhMucThucPham } from '@/services/DanhMucThucPham';

export default () => {
  const [danhSach, setDanhSach] = useState<QuanLyLop.Record[]>([]);
  const [danhSachTp, setDanhSachTp] = useState<IDanhMucThucPham.Record[]>([]);
  const [danhSachCreateTp, setDanhSachCreateTp] = useState<IDanhMucThucPham.Record[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [total, setTotal] = useState<number>(0);
  const [record, setRecord] = useState<QuanLyLop.Record>({} as any);
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);
  const [cond, setCondition] = useState<any>({});
  const [filterInfo, setFilterInfo] = useState<any>({});
  const [visibleForm, setVisibleForm] = useState<boolean>(false);
  const [edit, setEdit] = useState<boolean>(false);

  const { initialState } = useModel('@@initialState');
  const parent = initialState?.currentUser?.role?.organizationId;
  const vaiTro = localStorage.getItem('vaiTro');

  const getQuyDoiModel = async (donViId?: string) => {
    setLoading(true);
    const response = await getQuyDoi({ page, limit, cond, donViId });
    setDanhSach(response?.data?.data?.result ?? []);
    setTotal(response?.data?.data?.total ?? 0);
    setLoading(false);
  };
  const createQuyDoiModel = async (data: IQuiDoi.DataCreate) => {
    setLoading(true);
    const response = await createQuyDoi(data);
    if (response) {
    }
    setLoading(false);
  };
  const updateQuyDoiModel = async (data: IQuiDoi.DataUpdate) => {
    setLoading(true);
    const response = await updateQuyDoi(data);
    if(response) {
    }
    setLoading(false)
  }
  const deleteQuyDoiModel = async (id: string) => {
    setLoading(true);
    const response = await deleteQuyDoi(id);
    if (response) {
    }
    setLoading(false);
  };
  const getTPQuyDoi = async (donViId: string) => {
    const response = await getListThucPham(donViId);
    if (response) {
      setDanhSachCreateTp(response?.data?.data ?? []);
    }
  };

  const getDanhMucThucPhamModelQuyDoi = async (donViId?: string, limitOther?: number) => {
    setLoading(true);
    const response = await getDanhMucThucPhamQuyDoi({
      page,
      limit: limitOther ? limitOther : limit,
      cond: {
        // ...cond,
        ...(!donViId && { isRoot: true }),
        ...(donViId && {
          donViId: donViId,
          isRoot: false,
        }),
      },
    });
    setDanhSachTp(response?.data?.data?.result ?? []);
    // setTotal(response?.data?.data?.total);
    setLoading(false);
  };
  return {
    danhSach,
    record,
    setRecord,
    loading,
    setLoading,
    getQuyDoiModel,
    total,
    setTotal,
    page,
    limit,
    setPage,
    setLimit,
    cond,
    setCondition,
    filterInfo,
    setFilterInfo,
    setVisibleForm,
    visibleForm,
    edit,
    setEdit,
    createQuyDoiModel,
    updateQuyDoiModel,
    deleteQuyDoiModel,
    danhSachTp,
    getDanhMucThucPhamModelQuyDoi,
    getTPQuyDoi,
    danhSachCreateTp
  };
};
